import { render, staticRenderFns } from "./PrintPdfJsonProgrammatic.vue?vue&type=template&id=33022ebc&scoped=true"
import script from "./PrintPdfJsonProgrammatic.vue?vue&type=script&lang=js"
export * from "./PrintPdfJsonProgrammatic.vue?vue&type=script&lang=js"
import style0 from "./PrintPdfJsonProgrammatic.vue?vue&type=style&index=0&id=33022ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33022ebc",
  null
  
)

export default component.exports